export const selectBudgetManagementSystem = state => state.budgetManagementSystem.data
export const selectBudgetManagementSystemStatus = state => state.budgetManagementSystem.status
